import { render, staticRenderFns } from "./AlarmReceiverFormInput.vue?vue&type=template&id=006ca766&scoped=true&"
import script from "./AlarmReceiverFormInput.vue?vue&type=script&lang=ts&"
export * from "./AlarmReceiverFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmReceiverFormInput.vue?vue&type=style&index=0&id=006ca766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ca766",
  null
  
)

export default component.exports